import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-swap',
  templateUrl: './swap.component.html',
  styleUrls: ['./swap.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwapIconComponent {}
